<!-- 创建时间2023/06/14 19:31:45 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：表单-封面 -->
<template>
  <div class="yxtbiz-kng-operator__cover">
    <yxt-image :src="coverUrl"></yxt-image>
    <div class="yxtbiz-kng-operator__cover-set standard-size-12" @click="set">
      {{ $t('pc_biz_setCover'/** 设置封面 */) }}
    </div>
    <cover-drawer ref="drawer" />
  </div>
</template>

<script>
import coverDrawer from './cover-drawer.vue';
export default {
  name: 'form-cover',
  components: { coverDrawer },
  props: {
    type: {
      // 0上传 1随机 3知识类型 4智能
      type: Number,
      default: 1
    },
    coverUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    set() {
      this.$refs.drawer.init(this.type, this.coverUrl).then(res => {
        this.$emit('update:type', res.type);
        this.$emit('update:coverUrl', res.coverUrl);
      });
    }
  }
};
</script>